module.exports = "div{width:100%;max-width:100%;max-height:90vh}img.big{cursor:zoom-out;height:100%}img.small{cursor:zoom-in;height:100vh}\n"